import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import {
    useEffect,
    useMemo
} from "react";
import {
    getConfigValue
} from "@jutro/config";
import {
    getGenericAuthClient
} from "./generic/GenericAuthClient";
import {
    getNativeOktaAuthClient
} from "@jutro/auth/clients/okta/OktaAuthClient";
export var useAuthClient = function(basePath) {
    var useNativeOktaClient = useMemo((function() {
            return getConfigValue("JUTRO_AUTH_USE_NATIVE_OKTA_CLIENT", !1)
        }), []),
        authClient = useMemo((function() {
            return useNativeOktaClient ? getNativeOktaAuthClient(basePath) : getGenericAuthClient(basePath)
        }), [basePath, useNativeOktaClient]);
    return useEffect((function() {
        var _authClient$start, startResult = null === (_authClient$start = authClient.start) || void 0 === _authClient$start ? void 0 : _authClient$start.call(authClient);
        return function() {
            var _ref, cleanupClient = (_ref = _asyncToGenerator(_regeneratorRuntime.mark((function _callee() {
                var _authClient$cleanup;
                return _regeneratorRuntime.wrap((function(_context) {
                    for (;;) switch (_context.prev = _context.next) {
                        case 0:
                            if (!startResult) {
                                _context.next = 3;
                                break
                            }
                            return _context.next = 3, startResult;
                        case 3:
                            return _context.abrupt("return", null === (_authClient$cleanup = authClient.cleanup) || void 0 === _authClient$cleanup ? void 0 : _authClient$cleanup.call(authClient));
                        case 4:
                        case "end":
                            return _context.stop()
                    }
                }), _callee)
            }))), function() {
                return _ref.apply(this, arguments)
            });
            cleanupClient()
        }
    }), [authClient]), authClient
};
